<template>
  <div class="home">
    <div class="abc">
    <div class="card-deck justify-content-center">
      <div class="card text-center">
        <img class="card-img-top" src="../assets/fitagoras_0.png" alt="Card image cap">
        <div class="card-body">
          <h4 class="card-title">Fitagoras</h4>
          <p class="card-text">Puzzle Game</p>
          <a href="https://apps.apple.com/us/app/fitagoras/id1495054714" class="card-link"><img src="../assets/appstore.svg" alt=""/></a>
          <span></span>
          <a href="https://play.google.com/store/apps/details?id=com.Company.Fitagoras" class="card-link"><img src="../assets/google-play-badge.svg" alt=""/></a>

        </div>
      </div>
    </div>
    </div>
    <footer class="footer">
      <div class="container">
        <p class="text-muted">Apple and the Apple logo are registered trademarks of Apple Inc. App Store is a service mark of Apple Inc.
          Google Play and the Google Play logo are trademarks of Google LLC.
        </p>
      </div>
    </footer>
      <!--            <button type="submit"><img src="../assets/appstore.svg" alt=""/></button>
            <button type="submit"><img src="../assets/google-play-badge.png" alt=""/></button>
            <a href="#" class="btn btn-primary">Go somewhere</a>
      <div class="card text-center">
        <img class="card-img-top" src="../assets/1.jpg" alt="Card image cap">
        <div class="card-body">
          <h4 class="card-title">Card Title</h4>
          <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
          <a href="#" class="btn btn-primary">Go up</a>
        </div>
      </div>

      </div>-->
      <!--

      <div class="card" style="width:20rem;">
        <img class="card-img-top" src="../assets/2.jpg" alt="Card image cap">
        <div class="card-body">
          <h4 class="card-title">Card Title</h4>
          <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
          <a href="#" class="btn btn-primary">Go somewhere</a>
          </div>
      </div>
      <div class="card" style="width:20rem;">
        <img class="card-img-top" src="../assets/3.jpg" alt="Card image cap">
        <div class="card-body">
          <h4 class="card-title">Card Title</h4>
          <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
          <a href="#" class="btn btn-primary">Go somewhere</a>
          </div>
      </div>
-->
      <!--
      <img alt="Vue logo" class="img-responsive center-block" src="../assets/0.jpg">-->
    
    <!--
    <HelloWorld msg="HelloWorld"/>-->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }

}
</script>
<style>
.img-responsive{
  padding: 30px;
  width:150px;

}
.card{
  max-width:400px;

}
.mx-auto {
  width: 200px;
  margin: 0 auto; 
}
.abc{
  padding-top:40px;
}
.a{
  padding:30px;
}
button {
  padding: 30;
  border: none;
  background: transparent;
}

button img {
  display: block;
}

.footer {

bottom: 0;
width: 100%;
/* Set the fixed height of the footer here */
height: 60px;
background-color: #f5f5f5;
}
body > .container {
padding: 60px 15px 0;
}
.container .text-muted {
margin: 20px 0;
padding-top:10px;
}
 
.footer > .container {
padding-right: 15px;
padding-left: 15px;

}
</style>